import { useLazyQuery } from '@apollo/client'

import {
   convertToErrorType,
   CustomError,
   getAPIStatusFromNetworkStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'
import { APIStatus } from '@flowwai-frontend/shared/api-common'

import { FilterFieldsConfigType } from '../../types/filterTypes'

import {
   GetSearchAndMonitoringConfigQuery as Query,
   GetSearchAndMonitoringConfigDocument as QueryDocument,
   GetSearchAndMonitoringConfigQueryVariables as QueryVariables
} from './query.generatedTypes'

import useAPIResponseHandler from './responseHandler'

export interface FailureArgsType {
   data?: CustomError<Query['getSearchAndMonitoringConfig']>
   error?: Error | null
}

interface TriggerAPIArgsType {
   onFailure?: (args: FailureArgsType) => void
   onSuccess?: (onSuccess: FilterFieldsConfigType) => void
}

interface ReturnType {
   apiError: Error | null
   apiStatus: APIStatus

   triggerAPI: (args: TriggerAPIArgsType) => void
}

const useGetSearchAndMonitoringConfig = (): ReturnType => {
   const [
      getSearchAndMonitoringConfig,
      { data, error, networkStatus }
   ] = useLazyQuery<Query, QueryVariables>(QueryDocument)

   const { handleAPIResponse } = useAPIResponseHandler()

   const triggerAPI = (args: TriggerAPIArgsType): void => {
      getSearchAndMonitoringConfig({
         fetchPolicy: 'cache-first',

         onError: (error): void => {
            args.onFailure?.({ error })
         },
         onCompleted(data) {
            handleAPIResponse({
               data,
               onFailure(errorMessage, data) {
                  args.onFailure?.({
                     data: new CustomError(errorMessage, data)
                  })
               },
               onSuccess: args.onSuccess
            })
         }
      })
   }

   const apiError = convertToErrorType(error)

   const apiStatus = getAPIStatusFromNetworkStatus(networkStatus, data)

   return {
      apiError,
      apiStatus,

      triggerAPI
   }
}

export default useGetSearchAndMonitoringConfig
